module.exports = __webpack_public_path__ + "static/img/pipeline-wall-hole_64.842482a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pipeline-wall-hole_64.png
// module id = cC7i
// module chunks = 0